// @flow
import { makeStyles } from "@material-ui/styles";
export default makeStyles(() => ({
  root: {
    display: "flex",
    flexDirection: "row"
  },
  input: {
    marginRight: 8,
    flexGrow: 1
  },
  button: { flexShrink: 1 }
}), { index: 1 })